module.exports = __webpack_public_path__ + "img/ditu@3x.fc89c917.png";